/**
 * useImmersiveMode
 * ----------------
 * Tiny imperative hook for components that render a full-screen overlay
 * while staying on the same URL. Sets `body.dataset.immersive = 'true'`
 * for as long as the component flag is true, then clears it on unmount.
 *
 * GlobalBottomNav and GlobalBackButton read this flag and hide accordingly,
 * so we don't leak chrome into ritual / session overlays whose URL doesn't
 * indicate they are immersive.
 *
 * Usage:
 *   const ritualMode = ...;
 *   useImmersiveMode(ritualMode);
 */
import { useEffect } from 'react';

export const useImmersiveMode = (active) => {
  useEffect(() => {
    if (!active) return undefined;
    const body = document.body;
    const prev = body.dataset.immersive;
    body.dataset.immersive = 'true';
    return () => {
      if (prev) body.dataset.immersive = prev;
      else delete body.dataset.immersive;
    };
  }, [active]);
};

export default useImmersiveMode;
